/**
 * ZenMarkup Privacy Analytics — Insights module.
 *
 * Renders auto-generated insight cards on the Overview tab.
 * Data comes from ZMPA_Insights_Auto::get_auto_insights() via REST.
 */

import { formatDuration } from './charts.js';
import { setWidgetContent, emptyState, buildMultiColTable } from './table-builder.js';
import { build as listBuild } from './list.js';

/**
 * Inline SVG icons (16×16) for each insight type.
 */
const ICONS = {
	positive: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>',
	warning:  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
	alert:    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>'
};

/**
 * Render the insights strip from API data.
 *
 * @param {Object} data  Full stats response data.
 */
export function render(data) {
	const el = document.querySelector('[data-el="insights"]');
	const card = document.querySelector('[data-el="insights-card"]');
	if (!el) {
		return;
	}

	const raw = data.insights || {};
	const items = Array.isArray(raw) ? raw : (raw.items || []);

	if (!items.length) {
		if (card) card.style.display = 'none';
		return;
	}

	if (card) card.style.display = '';
	el.innerHTML = '';

	items.forEach(function (item) {
		const row = document.createElement('div');
		row.className = 'zmpa-insight-item zmpa-insight-' + (item.type || 'warning');

		const icon = document.createElement('span');
		icon.className = 'zmpa-insight-icon';
		icon.innerHTML = ICONS[item.type] || ICONS.warning;

		const text = document.createElement('span');
		text.className = 'zmpa-insight-text';
		text.textContent = item.message || '';

		row.appendChild(icon);
		row.appendChild(text);
		el.appendChild(row);
	});
}

/**
 * Render Dead Pages warning card.
 *
 * @param {Object} data  Full stats response data.
 */
export function renderDeadPages(data) {
	const section = document.getElementById('zmpa-dead-pages-section');
	const card = document.querySelector('[data-el="dead-pages"]');
	if (!card) {
		return;
	}

	const pages = data.dead_pages || [];
	if (!pages.length) {
		if (section) { section.style.display = 'none'; }
		return;
	}

	if (section) { section.style.display = ''; }

	const rows = pages.map(function (p) {
		return {
			name: p.url,
			count: Number(p.views).toLocaleString(),
			extra: [
				formatDuration(p.avg_duration),
				p.bounce_rate.toFixed(1) + '%'
			]
		};
	});
	setWidgetContent('dead-pages',
		buildMultiColTable(['Page', 'Views', 'Avg. Time', 'Bounce'], rows));
}

/**
 * Render the 404 Pages widget.
 *
 * @param {Object} data  Full stats response data.
 */
export function render404Pages(data) {
	var section = document.getElementById('zmpa-404-section');
	if (!section) {
		return;
	}

	var pages = data.pages_404 || [];
	if (!pages.length) {
		section.style.display = 'none';
		return;
	}

	section.style.display = '';

	var rows = pages.map(function (p) {
		return {
			name: p.url,
			count: Number(p.hits).toLocaleString()
		};
	});
	setWidgetContent('pages-404',
		listBuild('URL', 'Hits', rows));
}
